function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable behance/no-deprecated */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'react-fela'; // eslint-disable-line behance/no-deprecated

import getReactDisplayName from 'react-display-name';

function applyStaticStyles(staticStyles, ComponentToWrap) {
  var CompWithStaticStyles =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(CompWithStaticStyles, _PureComponent);

    function CompWithStaticStyles() {
      _classCallCheck(this, CompWithStaticStyles);

      return _possibleConstructorReturn(this, _getPrototypeOf(CompWithStaticStyles).apply(this, arguments));
    }

    _createClass(CompWithStaticStyles, [{
      key: "UNSAFE_componentWillMount",
      value: function UNSAFE_componentWillMount() {
        var contextTheme = this.props.theme || {};
        var result = typeof staticStyles === 'function' ? staticStyles(contextTheme) : staticStyles;
        this.context.renderer.renderStatic(result);
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            theme = _this$props.theme,
            passThroughProps = _objectWithoutProperties(_this$props, ["theme"]);

        return (
          /*#__PURE__*/
          React.createElement(ComponentToWrap, passThroughProps)
        );
      }
    }]);

    return CompWithStaticStyles;
  }(PureComponent);

  _defineProperty(CompWithStaticStyles, "contextTypes", {
    renderer: PropTypes.object
  });

  var WithThemeHOC = withTheme(CompWithStaticStyles);
  WithThemeHOC.displayName = getReactDisplayName(ComponentToWrap);
  return WithThemeHOC;
}

export default applyStaticStyles;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/style-container/es/applyStaticStyles.js
// module id = 1196
// module chunks = 0